import ButtonLink from "components/Buttons/ButtonLink";
import ScrollTo from "hooks/ScrollTo";
import React from "react";

function HeroCursos({ sectionLink }) {
  return (
    <section
      id="1"
      className="min-h-[80%] bg-primario flex flex-col justify-center items-center text-center gap-4 px-8 py-[25%] sm:py-[10%]  sm:px-6 lg:px-8"
    >
      <h2 className="text-secundario bg-secundario/20 border-2 border-secundario px-3 sm:px-4 py-1 rounded-full font-bold backdrop-blur-sm text-xs sm:text-sm md:text-base">
        Brighton, Educación de excelencia
      </h2>
      <h1 className="capitalize text-3xl sm:text-4xl md:text-5xl lg:text-7xl 2xl:text-8xl font-bold w-full sm:w-5/6 md:w-2/3 text-white leading-tight">
        Tu Futuro en <strong className="text-secundario">Inglés</strong>{" "}
        Comienza <strong className="text-secundario">Ahora</strong>
      </h1>
      <p className="text-white font-bold text-base sm:text-lg md:text-xl w-full sm:w-5/6 md:w-2/3">
        Cursos perfectos para desarrollar tus habilidades en inglés, trabarjar
        competencias específicas y alcanzar tus metas académicas y
        profesionales.
      </p>
      <div className="w-2/3 sm:w-full flex flex-col sm:flex-row gap-4 sm:justify-center sm:items-center">
        <ScrollTo text={"Ver Cursos"} to={sectionLink} />
        <ButtonLink href="https://wa.link/ks85ki" text="Agenda una clase gratis" />
        
      </div>
    </section>
  );
}

export default HeroCursos;
